import React from 'react';
import { motion } from 'framer-motion';
import { Scissors, BookOpen, Clapperboard } from 'lucide-react';
export function About() {
  return <section id="sobre-mi" className="py-32 relative overflow-hidden" data-id="element-9">
      {/* Background glow */}
      <div className="absolute top-1/2 right-0 w-1/2 h-1/2 bg-neon-green/10 rounded-full mix-blend-screen filter blur-[120px] -translate-y-1/2" data-id="element-10" />

      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-11">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-12">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-13">
            <div className="relative z-10 rounded-3xl overflow-hidden border border-white/10 aspect-[4/5] max-w-md mx-auto lg:mx-0" data-id="element-14">
              <img src="https://images.unsplash.com/photo-1618085220188-b4f210d22703?auto=format&fit=crop&q=80&w=800" alt="Nicolas Marshall" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" data-id="element-15" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent" data-id="element-16" />
            </div>

            {/* Decorative elements */}
            <div className="absolute -inset-4 border border-neon-violet/30 rounded-[2rem] -z-10 transform rotate-3" data-id="element-17" />
            <div className="absolute -inset-4 border border-neon-green/30 rounded-[2rem] -z-10 transform -rotate-2" data-id="element-18" />
          </motion.div>

          {/* Content Side */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-19">
            <h2 className="font-display text-6xl md:text-8xl mb-6" data-id="element-20">
              Nicolas <br data-id="element-21" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-500" data-id="element-22">
                Marshall
              </span>
            </h2>

            <div className="flex flex-wrap gap-3 mb-8" data-id="element-23">
              <div className="px-4 py-2 rounded-full bg-white/5 border border-white/10 flex items-center gap-2 text-sm font-medium backdrop-blur-sm" data-id="element-24">
                <Scissors size={16} className="text-neon-violet" data-id="element-25" />
                Barbero
              </div>
              <div className="px-4 py-2 rounded-full bg-white/5 border border-white/10 flex items-center gap-2 text-sm font-medium backdrop-blur-sm" data-id="element-26">
                <BookOpen size={16} className="text-neon-green" data-id="element-27" />
                Educador
              </div>
              <div className="px-4 py-2 rounded-full bg-white/5 border border-white/10 flex items-center gap-2 text-sm font-medium backdrop-blur-sm" data-id="element-28">
                <Clapperboard size={16} className="text-fuchsia-400" data-id="element-29" />
                Actor
              </div>
            </div>

            <div className="space-y-6 text-gray-400 text-lg leading-relaxed" data-id="element-30">
              <p data-id="element-31">
                Con base en El Pinar, Canelones, he dedicado mi carrera a
                fusionar el arte urbano con la precisión técnica. No solo corto
                cabello; esculpo identidades.
              </p>
              <p data-id="element-32">
                Mi especialidad radica en la colorimetría extrema y los cortes
                de autor. Como educador, mi misión es elevar el estándar de la
                barbería en Uruguay, formando a la próxima generación de
                artistas del cabello.
              </p>
              <p data-id="element-33">
                La disciplina del actor y la visión del barbero se unen en{' '}
                <strong className="text-white font-semibold" data-id="element-34">
                  Barbería Ninja 2.0
                </strong>
                , un espacio donde cada servicio es una obra maestra.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-6 mt-12 pt-12 border-t border-white/10" data-id="element-35">
              <div data-id="element-36">
                <p className="font-display text-5xl text-white mb-1" data-id="element-37">+5</p>
                <p className="text-sm text-gray-500 uppercase tracking-wider font-semibold" data-id="element-38">
                  Años de Experiencia
                </p>
              </div>
              <div data-id="element-39">
                <p className="font-display text-5xl text-white mb-1" data-id="element-40">+200</p>
                <p className="text-sm text-gray-500 uppercase tracking-wider font-semibold" data-id="element-41">
                  Alumnos Formados
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}